<template>
  <div
    v-show="$store.state.modalCronograma"
    id="CronometroCont"
    class="cronometroCont ui-draggable ui-draggable-handle"
    style="display: block;"
  >
    <div @click="cerrarCronometro" class="cronometroCont-cerrar"></div>
    <div class="chronoExample">
      <div class="valuesCrono">
        <span id="hour">00h</span>&nbsp
        <span id="minute">00m</span>&nbsp
        <span id="second">00s</span>
      </div>
      <div class="centradoCrono">
        <div id="btn-comenzar" class="startButtonCrono startCrono">{{literal["CRONOMETRO"]["INICIAR"]}}</div>
        <div id="btn-Reset" class="resetButtonCrono resetCrono">{{literal["CRONOMETRO"]["REINICIAR"]}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapState } from 'vuex'

export default {
  name: "ModalCronometro",

  data: () => ({}),
  methods: {
    cerrarCronometro(){
      this.$store.state.modalCronograma = false;
    }
  },
  computed: {
    ...mapState(['literal'])
  },
  mounted: function() {
    $(document).ready(() => {
      let top = ($(window).height() - $('#CronometroCont').height()) / 2;
      let left = ($(window).width() - $('#CronometroCont').width()) / 2;
      $('#CronometroCont').css({'top': top + 'px', 'left':  left + 'px'})
    });

    let cronometro = document.getElementById('CronometroCont');
    let viewer = document.getElementById('viewer');
    let seleccionado = false;
    let x = 0;
    let y = 0;
    let iniciar = this.literal["CRONOMETRO"]["INICIAR"];
    let detener = this.literal["CRONOMETRO"]["DETENER"];

    //Se Agrega los listener correpondiente a los movimientos que se hacen en el cronometro
    let agregarListener = () => {
      cronometro.addEventListener("mousedown", cronometrodown);
      cronometro.addEventListener("mousemove", cronometromove);
      cronometro.addEventListener("mouseup", cronometroup);
      cronometro.addEventListener("touchstart", cronometrotouch);
      cronometro.addEventListener("touchmove", cronometrotouchmove);
      cronometro.addEventListener("touchend", cronometrotouchend);
      // cronometro.addEventListener("touchstart", cronometrodown);
      // cronometro.addEventListener("touchmove", cronometromove);

      viewer.addEventListener("mousedown", cronometrodown);
      viewer.addEventListener("mousemove", cronometromove);
      viewer.addEventListener("mouseup", cronometroup);
      viewer.addEventListener("touchstart", cronometrotouch);
      viewer.addEventListener("touchmove", cronometrotouchmove);
      viewer.addEventListener("touchend", cronometrotouchend);
    };

    let cronometrodown = (e) => {
      if (e.target.id == 'CronometroCont' || e.target.className == 'chronoExample') {
        seleccionado = true;
        if(e.clientX && e.clientY) {
          x = e.clientX;
          y = e.clientY;
        } else {
          x = e.touches[0].clientX;
          y = e.touches[0].clientY;
        }
      } 
    }

    let cronometrotouch = (e) => {
      if (e.target.id == 'CronometroCont' || e.target.className == 'chronoExample') {
        seleccionado = true;
        x = e.changedTouches[0].pageX;
        y = e.changedTouches[0].pageY;
      } 
    }

    let cronometromove = (e) => {
      if (seleccionado) {
        if(e.clientX && e.clientY) {
          x = e.clientX - (x - $('#CronometroCont').css('left').split('px')[0]);
          y = e.clientY - (y - $('#CronometroCont').css('top').split('px')[0]);
        } else {
          x = e.touches[0].clientX - (x - $('#CronometroCont').css('left').split('px')[0]);
          y = e.touches[0].clientY - (y - $('#CronometroCont').css('top').split('px')[0]);
        }
        
        $('#CronometroCont').css({'top': y + 'px', 'left': x + 'px'})

        if($('#CronometroCont').css('left').split('px')[0] < 0) {
          $('#CronometroCont').css({'top': y + 'px', 'left': 0.01 + 'px'})
        } 
        
        if ($(window).width() < parseInt($('#CronometroCont').css('left').split('px')[0]) + $('#CronometroCont').width()) {
          $('#CronometroCont').css({'top': y + 'px', 'left': $(window).width() - $('#CronometroCont').width() + 'px'})
        } 

        if($('#CronometroCont').css('top').split('px')[0] < 56) {
          $('#CronometroCont').css({'top': 100 + 'px', 'left': x + 'px'})
        } 

        if ($(window).height() - 56 < parseInt($('#CronometroCont').css('top').split('px')[0]) + $('#CronometroCont').height()) {
          $('#CronometroCont').css({'top': $(window).height() - $('#CronometroCont').height() - 100 + 'px', 'left': x + 'px'})
        }

        x = e.clientX;
        y = e.clientY;
      }
    }

    let cronometrotouchmove = (e) => {
      if (seleccionado) {
        x = e.changedTouches[0].pageX - (x - $('#CronometroCont').css('left').split('px')[0]);
          y = e.changedTouches[0].pageY - (y - $('#CronometroCont').css('top').split('px')[0]);
        
        $('#CronometroCont').css({'top': y + 'px', 'left': x + 'px'})

        if($('#CronometroCont').css('left').split('px')[0] < 0) {
          $('#CronometroCont').css({'top': y + 'px', 'left': 0.01 + 'px'})
        } 
        
        if ($(window).width() < parseInt($('#CronometroCont').css('left').split('px')[0]) + $('#CronometroCont').width()) {
          $('#CronometroCont').css({'top': y + 'px', 'left': $(window).width() - $('#CronometroCont').width() + 'px'})
        } 

        if($('#CronometroCont').css('top').split('px')[0] < 56) {
          $('#CronometroCont').css({'top': 100 + 'px', 'left': x + 'px'})
        } 

        if ($(window).height() - 56 < parseInt($('#CronometroCont').css('top').split('px')[0]) + $('#CronometroCont').height()) {
          $('#CronometroCont').css({'top': $(window).height() - $('#CronometroCont').height() - 100 + 'px', 'left': x + 'px'})
        }

        x = e.changedTouches[0].pageX;
        y = e.changedTouches[0].pageY;
      }
    }

    let cronometroup = () => {
      if (seleccionado == true){
        seleccionado = false;
      }
    }

    let cronometrotouchend = () => {
      if (seleccionado == true){
        seleccionado = false;
      }
    }

    agregarListener();

    /** LOGICA DEL CRONOMETRO */
    var tiempo = {
      hora: 0,
      minuto: 0,
      segundo: 0,
    };

    var tiempo_corriendo = null;

    $("#btn-comenzar").click(function () {
      if ($(this).text() == iniciar) {
        $(this).text(detener);
        $(this).css({
          "background-color": "red",
          color: "white",
        });
        tiempo_corriendo = setInterval(function () {
          // Segundos
          tiempo.segundo++;
          if (tiempo.segundo >= 60) {
            tiempo.segundo = 0;
            tiempo.minuto++;
          }

          // Minutos
          if (tiempo.minuto >= 60) {
            tiempo.minuto = 0;
            tiempo.hora++;
          }

          $("#hour").text(
            (tiempo.hora < 10 ? "0" + tiempo.hora : tiempo.hora) + "h"
          );
          $("#minute").text(
            (tiempo.minuto < 10 ? "0" + tiempo.minuto : tiempo.minuto) + "m"
          );
          $("#second").text(
            (tiempo.segundo < 10 ? "0" + tiempo.segundo : tiempo.segundo) + "s"
          );
        }, 1000);
      } else {
        $(this).text(iniciar);
        $(this).css({
          "background-color": "green",
          color: "white",
        });
        clearInterval(tiempo_corriendo);
      }
    });

    $("#btn-Reset").click(function () {
      tiempo = { hora: 0, minuto: 0, segundo: 0 };

      $("#hour").text("00h");
      $("#minute").text("00m");
      $("#second").text("00s");

      $("#btn-comenzar").text(iniciar);
      $("#btn-comenzar").css({
        "background-color": "white",
        color: "gray",
      });
      clearInterval(tiempo_corriendo);
    });

    $('.cronometroCont-cerrar').click(() => {
      tiempo = { hora: 0, minuto: 0, segundo: 0 };

    	$("#hour").text('00h');
    	$("#minute").text('00m');
    	$("#second").text('00s');

    	$("#btn-comenzar").text(this.literal["CRONOMETRO"]["INICIAR"]);
    	$("#btn-comenzar").css({
    		'background-color' : 'white',
    		'color' : 'gray'
    	});
    	clearInterval(tiempo_corriendo);
    });
  }
};
</script>

<style>
/********** CONT CRONO */

.cronometroCont {
  display:none;
  background-color: #3c3c3b;
  border: 2px solid black;
  width: 220px;
  height: auto;
  border-radius: 20px;
  position: absolute;
  left: 810px;
  top: 350px;
  z-index: 3;
  transform: scale(1.3);
}
.chronoExample {
  width: 90%;
  position: relative;
  margin: 30px auto 15px;
}
.centradoCrono {
  position: relative;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: no-wrap;
}
.startButtonCrono, .pauseButtonCrono, .resetButtonCrono {
  padding:4px 6px;
  border-radius: 10px;
  background-color: white;
  color: #fff;
  font-family: 'Open Sans';
  cursor: pointer;
  width: 100%;
  font-size: 90%;
  text-align: center;
  margin: 5px 6px;
  padding: 6px 12px;
  text-align: center;
}

.valuesCrono{
  text-align: center;
  font-size: 90%;
  padding: 5px 0;
  background-color: #adadad;
  border-radius: 10px;
  margin-top: -10px;
  margin-bottom: 10%;
  font-weight: bold;
   color: #3c3c3b
}
.startCrono{
  color: gray
}
.resetCrono{
 color: gray
}

.cropper-container {
  z-index: 1;
}

/* .modalPage_btn-cerrar, */
.cronometroCont-cerrar,
.addLinkBtnCont-cerrar {
  width: 30px;
  height: 30px;
  background-size: 30px 30px;
  background-image: url('../../assets/img/equis.png');
  display: block;
  position: absolute;
  cursor: pointer;
  z-index: 9;
  right: -14px;
  top: -14px;
  transition: all .1s ease-in;
}

/* .modalPage_btn-cerrar:hover, */
.cronometroCont-cerrar:hover,
.addLinkBtnCont-cerrar:hover {
  transform: scale(1.1)
}
</style>
